import {
  WBS_SAVE_COMPONENT_BEGIN,
  WBS_SAVE_COMPONENT_SUCCESS,
  WBS_SAVE_COMPONENT_FAILURE,
  WBS_SAVE_COMPONENT_DISMISS_ERROR,
} from './constants';


import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';
import {CREATE_PROJECT_MODEL_ACTION_CREATE} from '../../common/redux/constantes';


// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function saveComponent(component,action,args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: WBS_SAVE_COMPONENT_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let URL = SERVER_PATH + '/components';
      if(action === CREATE_PROJECT_MODEL_ACTION_CREATE)
      {
        component.component = 0;
        URL+="/create";
      }else{
        URL+="/edit";
      }

      axios.post(URL, {
        component:component
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          if(res.data.success === 1){

            dispatch({
              type: WBS_SAVE_COMPONENT_SUCCESS,
              data: res.data,
            });
            resolve(res);
          }else{
            dispatch({
            type: WBS_SAVE_COMPONENT_FAILURE,
            data: { error: "Internal error" },
          });
          reject("Internal error");
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: WBS_SAVE_COMPONENT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSaveComponentError() {
  return {
    type: WBS_SAVE_COMPONENT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case WBS_SAVE_COMPONENT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        saveComponentPending: true,
        saveComponentError: null,
      };

    case WBS_SAVE_COMPONENT_SUCCESS:
      // The request is success
      return {
        ...state,
        saveComponentPending: false,
        saveComponentError: null,
        openSnackBar:true,
        messageSnackBar:'Component saved'
      };

    case WBS_SAVE_COMPONENT_FAILURE:
      // The request is failed
      return {
        ...state,
        saveComponentPending: false,
        saveComponentError: action.data.error,
        openSnackBar:true,
        messageSnackBar:'Internal error'
      };

    case WBS_SAVE_COMPONENT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        saveComponentError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/wbs/redux/saveComponent.js